export const SIDEBAR_WIDTH = "255px";
export const HEADER_HEIGHT = "72px";
export const PAGE_TOP_CONTROLS_HEIGHT = "50px";

export const BREAKPOINTS = {
  DESKTOP_MEDIUM: 1600,
  DESKTOP: 1366,
  MOBILE: 1024,
};

export const BREAKPOINTS_VERTICAL = { DESKTOP: 768 };

export const MEDIA_QUERIES = {
  DESKTOP: `@media screen and (min-width: ${BREAKPOINTS.DESKTOP_MEDIUM + 1}px)`,
  MEDIUM_DESKTOP: `@media screen and (max-width: ${BREAKPOINTS.DESKTOP_MEDIUM}px)`,
  SMALL_DESKTOP: `@media screen and (max-width: ${BREAKPOINTS.DESKTOP}px), screen and (max-height: ${BREAKPOINTS_VERTICAL.DESKTOP}px)`,
  MOBILE: `@media screen and (max-width: ${BREAKPOINTS.MOBILE}px)`,
};
